import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { AuthMicrosoftService } from '../../../core/services/auth.microsoft.service';
import { AlertService } from '@ed---interne/ng-uui-components';

@Component({
    selector: 'app-azure-callback',
    template: '<p>Connexion Microsoft…</p>',
    standalone: true,
})
export class AzureCallbackComponent implements OnInit {
    constructor(
        private microsoftAuth: AuthMicrosoftService,
        private auth: AuthService,
        private router: Router,
        private readonly alertService: AlertService,
    ) {}

    async ngOnInit() {
        try {
            //Échanger le token Microsoft contre ton token local
            const localToken = await this.microsoftAuth.exchangeForLocalToken({
                useAccessToken: false,
            });
            if (localToken) {
                await this.auth.registerToken(localToken);
            }
            // Revenir sur le workflow initial (home sécurisé par ex.)
            this.router.navigateByUrl('/main');
        } catch (e: any) {
            console.error('Exchange AAD <-> local failed', e);
            this.alertService.error(
                'Connexion via Microsoft Azure',
                e?.error?.message || 'Une erreur est survenue',
            );
            // UX: redirige vers la page de login avec un message si besoin
            this.router.navigateByUrl('/');
        }
    }
}
